export enum DurationUnit {
  "seconds" = "seconds",
  "minutes" = "minutes",
  "hours" = "hours",
  "days" = "days",
  "weeks" = "weeks",
  "months" = "months",
  "years" = "years",
}
